var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "course insicht insicht--fade-up" },
    [
      _c(
        "div",
        { staticClass: "course__list" },
        [
          _c("a", { ref: "startAnchor", staticClass: "anchor" }),
          _vm._v(" "),
          _c("h2", {
            directives: [
              {
                name: "sanitize",
                rawName: "v-sanitize",
                value: _vm.$t("course.title." + _vm.eventType),
                expression: "$t(`course.title.${eventType}`)"
              }
            ],
            staticClass: "course__title"
          }),
          _vm._v(" "),
          !_vm.selectedEvent
            ? [
                _vm.showRegionSelection
                  ? [
                      _c("div", { staticClass: "course__row" }, [
                        _c(
                          "div",
                          { staticClass: "course__row-items" },
                          [
                            _c("FormInputSelect", {
                              attrs: {
                                options: _vm.regionOptions,
                                label: _vm.$t("course.regionLabel"),
                                disabled: _vm.loading
                              },
                              model: {
                                value: _vm.selectedRegionCode,
                                callback: function($$v) {
                                  _vm.selectedRegionCode = $$v
                                },
                                expression: "selectedRegionCode"
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.isBooking && _vm.events.length
                  ? _c("div", { staticClass: "course__row" }, [
                      _c(
                        "div",
                        { staticClass: "course__row-items" },
                        [
                          _c("AvailabilityCalendar", {
                            staticClass: "course__calendar",
                            attrs: {
                              "min-date": _vm.availableMinDate,
                              "max-date": _vm.availableMaxDate,
                              availabilities: _vm.monthAvailabilities,
                              "hide-legend": "",
                              required: ""
                            },
                            on: { "change:month": _vm.onMonthChange },
                            model: {
                              value: _vm.selectedDate,
                              callback: function($$v) {
                                _vm.selectedDate = $$v
                              },
                              expression: "selectedDate"
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.showRegionSelection || _vm.selectedRegionCode
                  ? _vm._l(_vm.eventsByRegionsFiltered, function(region) {
                      return _c(
                        "div",
                        { key: region.code, staticClass: "course__row" },
                        [
                          !_vm.showRegionSelection &&
                          _vm.eventsByRegions[0].code !== "none" &&
                          (region.visibleEvents.length ||
                            (_vm.isBooking && _vm.selectedDate))
                            ? _c("h3", {
                                directives: [
                                  {
                                    name: "sanitize",
                                    rawName: "v-sanitize",
                                    value: region.name,
                                    expression: "region.name"
                                  }
                                ],
                                staticClass: "course__row-title"
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          region.visibleEvents.length
                            ? _c(
                                "div",
                                { staticClass: "course__row-items" },
                                _vm._l(region.visibleEvents, function(event) {
                                  return _c("CourseListItem", {
                                    key: event.id,
                                    attrs: {
                                      event: event,
                                      "button-text": _vm.$t(
                                        "course.chooseButton"
                                      )
                                    },
                                    on: {
                                      "course:select": _vm.onSelectDate,
                                      "course:info": _vm.onInfoModalOpen
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm.isBooking && _vm.selectedDate
                            ? _c("div", {
                                staticClass: "course__row-empty",
                                domProps: {
                                  innerHTML: _vm._s(_vm.$t("course.noDates"))
                                }
                              })
                            : _vm._e()
                        ]
                      )
                    })
                  : _vm._e(),
                _vm._v(" "),
                !_vm.events.length
                  ? _c("div", { staticClass: "course__row" }, [
                      _c("h3", {
                        directives: [
                          {
                            name: "sanitize",
                            rawName: "v-sanitize",
                            value: _vm.$t("course.noDates"),
                            expression: "$t('course.noDates')"
                          }
                        ],
                        staticClass: "course__row-title"
                      })
                    ])
                  : _vm._e()
              ]
            : [
                _c("div", { staticClass: "course__row" }, [
                  _c(
                    "div",
                    { staticClass: "course__row-items" },
                    [
                      _c("CourseListItem", {
                        attrs: { event: _vm.selectedEvent },
                        on: { "course:info": _vm.onInfoModalOpen }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    text: _vm.$t("course.resetButton"),
                    level: "tertiary",
                    arrow: ""
                  },
                  on: { click: _vm.onResetSelection }
                })
              ]
        ],
        2
      ),
      _vm._v(" "),
      _vm.form.eventId
        ? _c(
            "div",
            { staticClass: "checkout-form__container" },
            [
              _c("a", { ref: "formAnchor", staticClass: "anchor" }),
              _vm._v(" "),
              _c("h2", {
                directives: [
                  {
                    name: "sanitize",
                    rawName: "v-sanitize",
                    value: _vm.$t("course.formTitle"),
                    expression: "$t('course.formTitle')"
                  }
                ],
                staticClass: "course__title"
              }),
              _vm._v(" "),
              _vm.response.message
                ? _c("GeneralMessage", {
                    ref: "message",
                    attrs: {
                      message: _vm.response.message,
                      type: _vm.response.type,
                      stick: ""
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("ValidationObserver", {
                ref: "form",
                staticClass: "checkout-form__form-wrapper",
                attrs: { tag: "form", novalidate: "" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.onSubmit.apply(null, arguments)
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var invalid = ref.invalid
                        var errors = ref.errors
                        return [
                          !_vm.isBooking
                            ? _c(
                                "div",
                                { staticClass: "input-row" },
                                [
                                  _c("FormInputSelect", {
                                    attrs: {
                                      options: _vm.participants,
                                      label: _vm.$t("course.participantsLabel"),
                                      disabled: _vm.loading
                                    },
                                    model: {
                                      value: _vm.form.participants,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "participants", $$v)
                                      },
                                      expression: "form.participants"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("ValidationObserver", {
                            ref: "address",
                            attrs: { tag: "section", vid: "address" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var invalid = ref.invalid
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "input-row" },
                                        [
                                          _c("ValidationProvider", {
                                            staticClass: "input-row__wrapper",
                                            attrs: {
                                              name: "firstname",
                                              rules: "required",
                                              tag: "div",
                                              customMessages: {
                                                required: _vm.$t(
                                                  "forms.errors.fieldEmpty"
                                                )
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var errors = ref.errors
                                                    var invalid = ref.invalid
                                                    var validated =
                                                      ref.validated
                                                    return [
                                                      _c("FormInput", {
                                                        attrs: {
                                                          type: "text",
                                                          placeholder: _vm.$t(
                                                            "forms.labels.firstname"
                                                          ),
                                                          label: _vm.$t(
                                                            "forms.labels.firstname"
                                                          ),
                                                          name: "firstname",
                                                          error:
                                                            errors.length > 0,
                                                          disabled: _vm.loading,
                                                          required: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form.firstName,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "firstName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.firstName"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      invalid && validated
                                                        ? _c("span", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "sanitize",
                                                                rawName:
                                                                  "v-sanitize",
                                                                value:
                                                                  errors[0],
                                                                expression:
                                                                  "errors[0]"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "input-error"
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("ValidationProvider", {
                                            staticClass: "input-row__wrapper",
                                            attrs: {
                                              name: "lastname",
                                              rules: "required",
                                              tag: "div",
                                              customMessages: {
                                                required: _vm.$t(
                                                  "forms.errors.fieldEmpty"
                                                )
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var errors = ref.errors
                                                    var invalid = ref.invalid
                                                    var validated =
                                                      ref.validated
                                                    return [
                                                      _c("FormInput", {
                                                        attrs: {
                                                          type: "text",
                                                          placeholder: _vm.$t(
                                                            "forms.labels.lastname"
                                                          ),
                                                          label: _vm.$t(
                                                            "forms.labels.lastname"
                                                          ),
                                                          name: "lastname",
                                                          error:
                                                            errors.length > 0,
                                                          disabled: _vm.loading,
                                                          required: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form.lastName,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "lastName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.lastName"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      invalid && validated
                                                        ? _c("span", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "sanitize",
                                                                rawName:
                                                                  "v-sanitize",
                                                                value:
                                                                  errors[0],
                                                                expression:
                                                                  "errors[0]"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "input-error"
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-row" },
                                        [
                                          _c("FormInput", {
                                            attrs: {
                                              type: "text",
                                              placeholder: _vm.$t(
                                                "forms.labels.company"
                                              ),
                                              label: _vm.$t(
                                                "forms.labels.company"
                                              ),
                                              labelOption: _vm.$t(
                                                "forms.labels.optional"
                                              ),
                                              name: "company",
                                              required: false,
                                              disabled: _vm.loading
                                            },
                                            model: {
                                              value: _vm.form.company,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.form,
                                                  "company",
                                                  $$v
                                                )
                                              },
                                              expression: "form.company"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-row" },
                                        [
                                          _c("ValidationObserver", {
                                            staticClass: "input-row__wrapper",
                                            attrs: { tag: "div" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var validated =
                                                      ref.validated
                                                    var invalid = ref.invalid
                                                    var errors = ref.errors
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group"
                                                        },
                                                        [
                                                          _c(
                                                            "ValidationProvider",
                                                            {
                                                              staticClass:
                                                                "input-group__span-9",
                                                              attrs: {
                                                                name: "street",
                                                                rules:
                                                                  "required",
                                                                tag: "div",
                                                                customMessages: {
                                                                  required: _vm.$t(
                                                                    "forms.errors.fieldEmpty"
                                                                  )
                                                                }
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var errors =
                                                                        ref.errors
                                                                      var invalid =
                                                                        ref.invalid
                                                                      return [
                                                                        _c(
                                                                          "FormInput",
                                                                          {
                                                                            attrs: {
                                                                              type:
                                                                                "text",
                                                                              placeholder: _vm.$t(
                                                                                "forms.labels.street"
                                                                              ),
                                                                              label: _vm.$t(
                                                                                "forms.labels.street"
                                                                              ),
                                                                              name:
                                                                                "street",
                                                                              error:
                                                                                errors.length >
                                                                                0,
                                                                              disabled:
                                                                                _vm.loading,
                                                                              required:
                                                                                ""
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .form
                                                                                  .street,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.form,
                                                                                  "street",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "form.street"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "ValidationProvider",
                                                            {
                                                              staticClass:
                                                                "input-group__span-3",
                                                              attrs: {
                                                                name:
                                                                  "streetNumber",
                                                                rules:
                                                                  "required",
                                                                tag: "div",
                                                                customMessages: {
                                                                  required: _vm.$t(
                                                                    "forms.errors.fieldEmpty"
                                                                  )
                                                                }
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var errors =
                                                                        ref.errors
                                                                      var invalid =
                                                                        ref.invalid
                                                                      return [
                                                                        _c(
                                                                          "FormInput",
                                                                          {
                                                                            attrs: {
                                                                              type:
                                                                                "text",
                                                                              placeholder: _vm.$t(
                                                                                "forms.labels.number"
                                                                              ),
                                                                              label: _vm.$t(
                                                                                "forms.labels.number"
                                                                              ),
                                                                              name:
                                                                                "number",
                                                                              error:
                                                                                errors.length >
                                                                                0,
                                                                              disabled:
                                                                                _vm.loading,
                                                                              required:
                                                                                ""
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .form
                                                                                  .streetNumber,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.form,
                                                                                  "streetNumber",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "form.streetNumber"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      invalid && validated
                                                        ? _c("div", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "sanitize",
                                                                rawName:
                                                                  "v-sanitize",
                                                                value: Object.values(
                                                                  errors
                                                                )
                                                                  .filter(
                                                                    function(
                                                                      value
                                                                    ) {
                                                                      return !!value
                                                                        .join(
                                                                          ""
                                                                        )
                                                                        .trim()
                                                                    }
                                                                  )
                                                                  .join(" "),
                                                                expression:
                                                                  "Object.values(errors).filter(value => !!value.join('').trim()).join(' ')"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "input-error input-group__span-12"
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("ValidationObserver", {
                                            ref: "zipCity",
                                            staticClass: "input-row__wrapper",
                                            attrs: { tag: "div" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var dirty = ref.dirty
                                                    var validated =
                                                      ref.validated
                                                    var invalid = ref.invalid
                                                    var errors = ref.errors
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "input-group"
                                                        },
                                                        [
                                                          _c(
                                                            "ValidationProvider",
                                                            {
                                                              staticClass:
                                                                "input-group__span-4 input-group__span-xxl-3",
                                                              attrs: {
                                                                name: "zip",
                                                                rules:
                                                                  "required|digits:4",
                                                                tag: "div",
                                                                customMessages: {
                                                                  required: _vm.$t(
                                                                    "forms.errors.fieldEmpty"
                                                                  ),
                                                                  digits: _vm.$t(
                                                                    "forms.errors.zip"
                                                                  )
                                                                }
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var errors =
                                                                        ref.errors
                                                                      var invalid =
                                                                        ref.invalid
                                                                      return [
                                                                        _c(
                                                                          "FormInput",
                                                                          {
                                                                            ref:
                                                                              "courseZip",
                                                                            attrs: {
                                                                              type:
                                                                                "text",
                                                                              placeholder: _vm.$t(
                                                                                "forms.labels.zip"
                                                                              ),
                                                                              label: _vm.$t(
                                                                                "forms.labels.zip"
                                                                              ),
                                                                              name:
                                                                                "zip",
                                                                              minlength: 4,
                                                                              maxlength: 4,
                                                                              inputmode:
                                                                                "decimal",
                                                                              pattern:
                                                                                "[0-9]{4}",
                                                                              error:
                                                                                errors.length >
                                                                                0,
                                                                              disabled:
                                                                                _vm.loading,
                                                                              required:
                                                                                ""
                                                                            },
                                                                            on: {
                                                                              keydown:
                                                                                _vm.onZipKeydown,
                                                                              input:
                                                                                _vm.onZipInput
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .form
                                                                                  .postcode,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.form,
                                                                                  "postcode",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "form.postcode"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "ValidationProvider",
                                                            {
                                                              staticClass:
                                                                "input-group__span-8 input-group__span-xxl-9",
                                                              attrs: {
                                                                name: "city",
                                                                rules:
                                                                  "required",
                                                                tag: "div",
                                                                customMessages: {
                                                                  required: _vm.$t(
                                                                    "forms.errors.fieldEmpty"
                                                                  )
                                                                }
                                                              },
                                                              scopedSlots: _vm._u(
                                                                [
                                                                  {
                                                                    key:
                                                                      "default",
                                                                    fn: function(
                                                                      ref
                                                                    ) {
                                                                      var errors =
                                                                        ref.errors
                                                                      var invalid =
                                                                        ref.invalid
                                                                      return [
                                                                        _c(
                                                                          "FormInput",
                                                                          {
                                                                            attrs: {
                                                                              type:
                                                                                "text",
                                                                              placeholder: _vm.$t(
                                                                                "forms.labels.city"
                                                                              ),
                                                                              label: _vm.$t(
                                                                                "forms.labels.city"
                                                                              ),
                                                                              name:
                                                                                "city",
                                                                              error:
                                                                                errors.length >
                                                                                0,
                                                                              disabled:
                                                                                _vm.loading,
                                                                              required:
                                                                                ""
                                                                            },
                                                                            model: {
                                                                              value:
                                                                                _vm
                                                                                  .form
                                                                                  .city,
                                                                              callback: function(
                                                                                $$v
                                                                              ) {
                                                                                _vm.$set(
                                                                                  _vm.form,
                                                                                  "city",
                                                                                  $$v
                                                                                )
                                                                              },
                                                                              expression:
                                                                                "form.city"
                                                                            }
                                                                          }
                                                                        )
                                                                      ]
                                                                    }
                                                                  }
                                                                ],
                                                                null,
                                                                true
                                                              )
                                                            }
                                                          )
                                                        ],
                                                        1
                                                      ),
                                                      _vm._v(" "),
                                                      invalid &&
                                                      (validated || dirty)
                                                        ? _c("div", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "sanitize",
                                                                rawName:
                                                                  "v-sanitize",
                                                                value: Object.values(
                                                                  errors
                                                                )
                                                                  .filter(
                                                                    function(
                                                                      value
                                                                    ) {
                                                                      return !!value
                                                                        .join(
                                                                          ""
                                                                        )
                                                                        .trim()
                                                                    }
                                                                  )
                                                                  .join(" "),
                                                                expression:
                                                                  "Object.values(errors).filter(value => !!value.join('').trim()).join(' ')"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "input-error input-group__span-12"
                                                          })
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-row" },
                                        [
                                          _c("ValidationProvider", {
                                            staticClass: "input-row__wrapper",
                                            attrs: {
                                              name: "phone",
                                              rules: "required|phone",
                                              tag: "div",
                                              customMessages: {
                                                required: _vm.$t(
                                                  "forms.errors.fieldEmpty"
                                                ),
                                                phone: _vm.$t(
                                                  "forms.errors.phone"
                                                )
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var errors = ref.errors
                                                    var invalid = ref.invalid
                                                    var validated =
                                                      ref.validated
                                                    return [
                                                      _c("FormInput", {
                                                        attrs: {
                                                          type: "tel",
                                                          placeholder: _vm.$t(
                                                            "forms.labels.phone"
                                                          ),
                                                          label: _vm.$t(
                                                            "forms.labels.phone"
                                                          ),
                                                          name: "phone",
                                                          error:
                                                            errors.length > 0,
                                                          disabled: _vm.loading,
                                                          required: ""
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form
                                                              .phoneNumber,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "phoneNumber",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.phoneNumber"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      invalid && validated
                                                        ? _c("span", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "sanitize",
                                                                rawName:
                                                                  "v-sanitize",
                                                                value:
                                                                  errors[0],
                                                                expression:
                                                                  "errors[0]"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "input-error"
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        directives: [
                                                          {
                                                            name: "sanitize",
                                                            rawName:
                                                              "v-sanitize",
                                                            value: _vm.$t(
                                                              "course.phoneHint"
                                                            ),
                                                            expression:
                                                              "$t('course.phoneHint')"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "additional-info"
                                                      })
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          }),
                                          _vm._v(" "),
                                          _c("ValidationProvider", {
                                            staticClass: "input-row__wrapper",
                                            attrs: {
                                              name: "email",
                                              rules: "required|email",
                                              tag: "div",
                                              customMessages: {
                                                required: _vm.$t(
                                                  "forms.errors.fieldEmpty"
                                                ),
                                                email: _vm.$t(
                                                  "forms.errors.emailInvalid"
                                                )
                                              }
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function(ref) {
                                                    var errors = ref.errors
                                                    var invalid = ref.invalid
                                                    var validated =
                                                      ref.validated
                                                    return [
                                                      _c("FormInput", {
                                                        attrs: {
                                                          type: "email",
                                                          name: "email",
                                                          autocomplete: "email",
                                                          placeholder: _vm.$t(
                                                            "forms.labels.email"
                                                          ),
                                                          label: _vm.$t(
                                                            "forms.labels.email"
                                                          ),
                                                          error:
                                                            errors.length > 0,
                                                          disabled: _vm.loading,
                                                          required: ""
                                                        },
                                                        model: {
                                                          value: _vm.form.email,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form,
                                                              "email",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.email"
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      invalid && validated
                                                        ? _c("span", {
                                                            directives: [
                                                              {
                                                                name:
                                                                  "sanitize",
                                                                rawName:
                                                                  "v-sanitize",
                                                                value:
                                                                  errors[0],
                                                                expression:
                                                                  "errors[0]"
                                                              }
                                                            ],
                                                            staticClass:
                                                              "input-error"
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c("span", {
                                                        directives: [
                                                          {
                                                            name: "sanitize",
                                                            rawName:
                                                              "v-sanitize",
                                                            value: _vm.$t(
                                                              "course.emailHint"
                                                            ),
                                                            expression:
                                                              "$t('course.emailHint')"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "additional-info"
                                                      })
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "input-row" }, [
                            _c(
                              "div",
                              { staticClass: "input-row__wrapper" },
                              [
                                _c("FormInputTextarea", {
                                  attrs: {
                                    placeholder: _vm.$t("forms.labels.notes"),
                                    label: _vm.$t("forms.labels.notes"),
                                    labelOption: _vm.$t(
                                      "forms.labels.optional"
                                    ),
                                    disabled: _vm.loading
                                  },
                                  model: {
                                    value: _vm.form.notes,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "notes", $$v)
                                    },
                                    expression: "form.notes"
                                  }
                                })
                              ],
                              1
                            )
                          ]),
                          _vm._v(" "),
                          !_vm.isBooking && _vm.form.participants > 1
                            ? [
                                _c("h3", {
                                  directives: [
                                    {
                                      name: "sanitize",
                                      rawName: "v-sanitize",
                                      value: _vm.$t("course.participantsTitle"),
                                      expression:
                                        "$t('course.participantsTitle')"
                                    }
                                  ],
                                  staticClass: "course__subtitle"
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.form.participants - 1, function(
                                  participant
                                ) {
                                  return [
                                    _c("label", {
                                      directives: [
                                        {
                                          name: "sanitize",
                                          rawName: "v-sanitize",
                                          value: _vm.$t(
                                            "course.participantRowLabel",
                                            { number: participant }
                                          ),
                                          expression:
                                            "$t('course.participantRowLabel', { number: participant })"
                                        }
                                      ],
                                      staticClass: "input-row-label"
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "input-row" },
                                      [
                                        _c("ValidationProvider", {
                                          staticClass: "input-row__wrapper",
                                          attrs: {
                                            name: "firstname-" + participant,
                                            rules: "required",
                                            tag: "div",
                                            customMessages: {
                                              required: _vm.$t(
                                                "forms.errors.fieldEmpty"
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  var invalid = ref.invalid
                                                  var validated = ref.validated
                                                  return [
                                                    _c("FormInput", {
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: _vm.$t(
                                                          "forms.labels.firstname"
                                                        ),
                                                        label: _vm.$t(
                                                          "forms.labels.firstname"
                                                        ),
                                                        name: "firstname",
                                                        error:
                                                          errors.length > 0,
                                                        disabled: _vm.loading,
                                                        required: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .participantFirstNames[
                                                            participant - 1
                                                          ],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.participantFirstNames,
                                                            participant - 1,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "participantFirstNames[participant - 1]"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    invalid && validated
                                                      ? _c("span", {
                                                          directives: [
                                                            {
                                                              name: "sanitize",
                                                              rawName:
                                                                "v-sanitize",
                                                              value: errors[0],
                                                              expression:
                                                                "errors[0]"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "input-error"
                                                        })
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        }),
                                        _vm._v(" "),
                                        _c("ValidationProvider", {
                                          staticClass: "input-row__wrapper",
                                          attrs: {
                                            name: "lastname-" + participant,
                                            rules: "required",
                                            tag: "div",
                                            customMessages: {
                                              required: _vm.$t(
                                                "forms.errors.fieldEmpty"
                                              )
                                            }
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function(ref) {
                                                  var errors = ref.errors
                                                  var invalid = ref.invalid
                                                  var validated = ref.validated
                                                  return [
                                                    _c("FormInput", {
                                                      attrs: {
                                                        type: "text",
                                                        placeholder: _vm.$t(
                                                          "forms.labels.lastname"
                                                        ),
                                                        label: _vm.$t(
                                                          "forms.labels.lastname"
                                                        ),
                                                        name: "lastname",
                                                        error:
                                                          errors.length > 0,
                                                        disabled: _vm.loading,
                                                        required: ""
                                                      },
                                                      model: {
                                                        value:
                                                          _vm
                                                            .participantLastNames[
                                                            participant - 1
                                                          ],
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.participantLastNames,
                                                            participant - 1,
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "participantLastNames[participant - 1]"
                                                      }
                                                    }),
                                                    _vm._v(" "),
                                                    invalid && validated
                                                      ? _c("span", {
                                                          directives: [
                                                            {
                                                              name: "sanitize",
                                                              rawName:
                                                                "v-sanitize",
                                                              value: errors[0],
                                                              expression:
                                                                "errors[0]"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "input-error"
                                                        })
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            true
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                })
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c("FormInput", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: false,
                                expression: "false"
                              }
                            ],
                            ref: "captcha",
                            attrs: {
                              type: "text",
                              placeholder: _vm.$t(
                                "forms.labels.addressDetails"
                              ),
                              label: _vm.$t("forms.labels.addressDetails"),
                              name: _vm.captcha.id,
                              id: _vm.captcha.id,
                              required: ""
                            },
                            model: {
                              value: _vm.captcha.value,
                              callback: function($$v) {
                                _vm.$set(_vm.captcha, "value", $$v)
                              },
                              expression: "captcha.value"
                            }
                          }),
                          _vm._v(" "),
                          _vm.termsPage
                            ? _c("ValidationProvider", {
                                attrs: {
                                  rules: { required: { allowFalse: false } },
                                  name: "checkTerms",
                                  tag: "div",
                                  customMessages: {
                                    required: _vm.$t(
                                      "course.errorCancellationTerms"
                                    )
                                  }
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var invalid = ref.invalid
                                        var errors = ref.errors
                                        var validated = ref.validated
                                        return [
                                          _c(
                                            "FormInputCheckbox",
                                            {
                                              attrs: {
                                                name: "terms",
                                                value: "checkTerms",
                                                required: "",
                                                immediate: ""
                                              },
                                              model: {
                                                value: _vm.form.checkTerms,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "checkTerms",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.checkTerms"
                                              }
                                            },
                                            [
                                              _c("span", {
                                                directives: [
                                                  {
                                                    name: "sanitize",
                                                    rawName: "v-sanitize",
                                                    value: _vm.$t(
                                                      "course.cancellationTermsLabel",
                                                      { url: _vm.termsPage }
                                                    ),
                                                    expression:
                                                      "$t('course.cancellationTermsLabel', { url: termsPage })"
                                                  }
                                                ]
                                              })
                                            ]
                                          ),
                                          _vm._v(" "),
                                          invalid && validated
                                            ? _c("span", {
                                                directives: [
                                                  {
                                                    name: "sanitize",
                                                    rawName: "v-sanitize",
                                                    value: errors[0],
                                                    expression: "errors[0]"
                                                  }
                                                ],
                                                staticClass: "input-error"
                                              })
                                            : _vm._e()
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("Button", {
                            attrs: {
                              type: "submit",
                              level: "primary",
                              text: _vm.$t("course.submitButton"),
                              disabled: _vm.loading
                            }
                          })
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  1112452524
                )
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "Modal",
        {
          ref: "infoModal",
          attrs: { narrow: "" },
          on: { close: _vm.onInfoModalClose }
        },
        [
          _vm.infoModalEvent
            ? _c("CourseListItem", {
                attrs: {
                  event: _vm.infoModalEvent,
                  "button-text": _vm.form.eventId
                    ? ""
                    : _vm.$t("course.chooseButton"),
                  "show-description": "",
                  vertical: ""
                },
                on: { "course:select": _vm.onSelectDate }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }